import QuickReplyInput from './QuickReplyInput';

const quickReply = {
  id: 'quick-reply',
  name: 'Quick reply',
  Input: QuickReplyInput,
  setInitialContent: content => {
    return {
      text: content.text || '',
      responses: content.responses || []
    };
  },
  valid: content => {
    return (
      content.text.length > 0 &&
      content.responses.length > 0 &&
      content.responses.every(response => {
        return response.label && response.postback;
      })
    );
  },
  snippet: `{
    "type": "quick-reply",
    "content": {
      "text": "",
      "responses": [
        {"label": "", "postback": ""}
      ]
    }
}`
};

export default quickReply;
